import api from '@/modules/api'
import { mutationNames } from '@/store/storeKey'
import { removeDuplicates } from '@/modules/helper'
const state = {
  ChatModuleInfo: {
    'Id': 0,
    'PageTitle': '',
    'SubscriptionModuleActivation_Id': 0,
    'HeaderElements': '',
    'FooterElements': ''
  },
  Channels: [],
  ChatMessages: [],
  EditingChatChannelId: 0,
  OpenChatViewId: 0,
  BackupChatChannel: null,
  NewChatChannel: null,
  PageValue: 1,
  TakeValue: 10,
  UI: {
    activeCategoryTab: '',
    activeMainTab: 'image'
  },
  FirstTimeOpen: false
}

const getters = {
  ChatModuleInfo: state => state.ChatModuleInfo,
  Channels: state => state.Channels,
  ChatMessages: state => state.ChatMessages,
  IsEditing: state => state.EditingChatChannelId !== 0,
  IsChatOpen: state => state.OpenChatViewId !== 0,
  EditingChatChannel: state => {
    if (state.EditingChatChannelId === 0) {
      return {}
    }
    return state.Channels.find(channel => channel.id === state.EditingChatChannelId)
  },
  OpenChatView: state => {
    if (state.OpenChatViewId === 0) {
      return {}
    }
    return state.Channels.find(channel => channel.id === state.OpenChatViewId)
  },
  NewChatChannel: state => state.NewChatChannel,
  IsAddingNewChatChannel: state => state.NewChatChannel !== null,
  UI: state => state.UI,
  FirstTimeOpen: state => state.FirstTimeOpen,
  PageValue: state => state.PageValue,
  TakeValue: state => state.TakeValue
}

const mutations = {
  RESET_MODULE_DATA (state) {
    state.ChatModuleInfo = {}
    state.Channels = []
    state.EditingChatChannelId = 0
    state.OpenChatViewId = 0
    state.BackupChatChannel = null
    state.NewChatChannel = null
    state.FirstTimeOpen = false
    state.UI = {
      activeCategoryTab: '',
      activeMainTab: 'CreateChannel'
    }
  },
  [mutationNames.SET_CHAT_MODULE_INFO] (state, Info) {
    state.ChatModuleInfo = Info
  },
  [mutationNames.UPDATE_CHAT_MODULE_INFO] (state, obj) {
    Object.assign(state.ChatModuleInfo, obj)
  },
  [mutationNames.SET_CHAT_CHANNEL] (state, Channel) {
    state.Channels = Channel
  },
  // [mutationNames.SET_CHAT_MESSAGES] (state, payload) {
  //   state.ChatMessages = payload
  // },
  [mutationNames.SET_CHAT_MESSAGES] (state, Msg) {
    if (Msg.length > 0) {
      let arr = [...state.ChatMessages, ...Msg]
      let arr4 = removeDuplicates(arr, 'id')
      state.ChatMessages = arr4
    } else {
      state.ChatMessages = []
    }
  },
  [mutationNames.UPDATE_CHAT_CHANNEL] (state, payload) {
    let channel = state.Channels.find(channel => channel.id === payload.id)
    if (channel) {
      Object.assign(channel, payload)
    }
  },
  [mutationNames.UPDATE_OPEN_CHAT] (state, payload) {
    let channel = state.Channels.find(channel => channel.id === payload.id)
    if (channel) {
      Object.assign(channel, payload)
    }
  },
  [mutationNames.UPDATE_CONTENT_PAGE_IMAGE] (state, { Id, payload }) {
    const contentPage = state.ContentPages.find(page => page.Id === Id)
    if (contentPage) {
      contentPage.PostImage = payload.PostImage
    }
  },
  [mutationNames.UPDATE_CHAT_CHANNEL_IMAGE] (state, uploadResponse) {
    let channel = state.Channels.find(channel => channel.id === uploadResponse.id)
    if (channel) {
      channel.channelImage = uploadResponse.channelImage ? uploadResponse.channelImage : null
    }
  },
  [mutationNames.ADD_CHATCHANNEL] (state, payload) {
    let channel = state.Channels.find(channel => channel.Id === payload.id)
    if (!channel) {
      state.Channels.push(payload)
    }
  },
  [mutationNames.CREATE_NEW_CHAT_CHANNEL] (state, payload) {
    state.NewChatChannel = payload
  },
  [mutationNames.UPDATE_NEW_CHAT_CHANNEL] (state, payload) {
    state.NewChatChannel = Object.assign({}, state.NewChatChannel, payload)
  },
  [mutationNames.SET_CHAT_CHANNEL_EDITING] (state, ChannelId) {
    state.EditingChatChannelId = ChannelId
    state.BackupChatChannel = Object.assign({}, state.Channels.find(channel => channel.id === ChannelId))
  },
  [mutationNames.SET_OPEN_CHAT_Id] (state, ChannelId) {
    state.OpenChatViewId = ChannelId
    state.BackupChatChannel = Object.assign({}, state.Channels.find(channel => channel.id === ChannelId))
  },
  [mutationNames.CANCEL_CHAT_CHANNEL_EDITING] (state, BackupChatChannel) {
    const index = state.Channels.findIndex(channel => channel.id === state.EditingChatChannelId)
    state.Channels.splice(index, 1, BackupChatChannel)
  },
  [mutationNames.CLEAR_CHAT_CHANNEL_EDITING_DATA] (state) {
    state.EditingChatChannelId = 0
    state.OpenChatViewId = 0
    state.BackupChatChannel = null
    state.NewChatChannel = null
    state.ChatMessages = []
  },
  UPDATE_UI (state, payload) {
    Object.assign(state.UI, payload)
  },
  setFirstTimeOpenValue (state, payload) {
    state.FirstTimeOpen = payload
  },
  setpageValue (state, pageval) {
    state.PageValue = pageval
  },
  settakeValue (state, takeval) {
    state.TakeValue = takeval
  }
}
const actions = {
  async initModule ({ getters, commit, dispatch }, ModuleInfo) {
    dispatch('resetModuleData')
    const response = await dispatch('populateChatModule', ModuleInfo.subscriptionModuleId)
    let payload = {
      ModulesChatsChannelsId: response.Id,
      SubscriptionModuleId: ModuleInfo.subscriptionId
    }
    await dispatch('populateChatModuleChannel', payload)
  },
  updateUI ({ commit }, payload) {
    commit('UPDATE_UI', payload)
  },
  resetModuleData ({ commit }) {
    commit('RESET_MODULE_DATA')
  },
  async populateChatModule ({ commit }, subscriptionModuleId) {
    const response = await api.AppModules.GetChatModule(subscriptionModuleId)
    if (!response) {
      throw new Error('No data from API. ;(')
    }
    commit(mutationNames.SET_CHAT_MODULE_INFO, response[0])
    return response[0]
  },
  async populateChatModuleChannel ({ commit }, payload) {
    const response = await api.AppModules.GetChatChannel(payload.ModulesChatsChannelsId, payload.SubscriptionModuleId)
    if (!response) {
      throw new Error('No data from API. ;(')
    }
    commit(mutationNames.SET_CHAT_CHANNEL, response)
    return response
  },
  editChatChannel ({ commit }, AlbumId) {
    commit(mutationNames.SET_CHAT_CHANNEL_EDITING, AlbumId)
  },
  openChatViewPage ({ commit }, ChannelId) {
    commit(mutationNames.SET_OPEN_CHAT_Id, ChannelId)
  },
  closeChatChannelEditingPage ({ commit }) {
    commit(mutationNames.CLEAR_CHAT_CHANNEL_EDITING_DATA)
  },
  async cancelChatChannelEditing ({ state, commit }) {
    await commit(mutationNames.CANCEL_CHAT_CHANNEL_EDITING, Object.assign({}, state.BackupChatChannel))
    await commit(mutationNames.CLEAR_CHAT_CHANNEL_EDITING_DATA)
  },
  updateEditingChatChannel ({ commit, state }, payload) {
    commit(mutationNames.UPDATE_CHAT_CHANNEL, payload)
  },
  updateOpenChatView ({ commit, state }, payload) {
    commit(mutationNames.UPDATE_OPEN_CHAT, payload)
  },
  createNewChatChannel ({ commit }, payload) {
    commit(mutationNames.CREATE_NEW_CHAT_CHANNEL, payload)
  },
  updateNewChatChannel ({ commit }, payload) {
    commit(mutationNames.UPDATE_NEW_CHAT_CHANNEL, payload)
  },
  updateChatModuleInfo ({ commit }, payload) {
    commit(mutationNames.UPDATE_IMAGE_GALLERIE_ChatModuleInfo, payload)
  },
  async addChatChannel ({ commit, dispatch }, payload) {
    const response = await dispatch('saveChatChannel', payload)
    return response
  },
  async saveChatChannel ({ commit }, payload) {
    const response = await api.AppModules.SaveChatChannelInfo(payload)
    return response
  },
  setFirstTimeOpenValue ({ commit }, payload) {
    commit('setFirstTimeOpenValue', payload)
  },
// ----------------------chat module actions -------------------------------//
  updateChatSettings ({dispatch, commit}, payload) {
    commit(mutationNames.UPDATE_CHAT_MODULE_INFO, payload)
    dispatch('savechatSettings', payload)
  },
  updateChannelSettings ({commit}, obj) {
    commit(mutationNames.UPDATE_CHAT_CHANNEL, obj)
  },
  updatChatHistory ({ commit }, payload) {
    commit(mutationNames.SET_CHAT_MESSAGES, payload)
  },
  async getChatMessages ({commit, getters}, payload) {
    // let totalmsginGroup = await api.AppModules.GetChatMessagesCount(payload.channelId)
    const response = await api.AppModules.GetChatMessagesByCount(payload.channelId, payload.skip, payload.take)
    if (!response) {
      throw new Error('No data from API. ;(')
    } else if (response.length > 0) {
      let at = []
      if (getters.ChatMessages.length > 0) {
        Object.assign(at, getters.ChatMessages)
      }
      Object.assign(at, response)
      commit(mutationNames.SET_CHAT_MESSAGES, at)
    }
  },
  async getlatestMessages ({commit, getters}, payload) {
    const response = await api.AppModules.GetLatestChatMessage(payload.channelId, payload.take)
    if (!response) {
      throw new Error('No data from API. ;(')
    } else if (response.length > 0) {
      let arr = []
      if (getters.ChatMessages.length > 0) {
        Object.assign(arr, getters.ChatMessages)
        arr.push(...response)
      }
      commit(mutationNames.SET_CHAT_MESSAGES, arr)
    }
  },
  savechatSettings ({dispatch, getters}) {
    let ChatModuleInfoClone = Object.assign({}, getters.ChatModuleInfo)
    return api.AppModules.SavechatSettings(ChatModuleInfoClone)
  },
  deleteChatChannel ({dispatch, getters}, channelId) {
    return api.AppModules.DeleteChatChannel(channelId)
  },
  async updateChatChannelImage ({getters, commit}, uploadResponse) {
    if (uploadResponse && uploadResponse.id !== '00000000-0000-0000-0000-000000000000') {
      let channel = getters.Channels.find(channel => channel.id === uploadResponse.id)
      let newchannel = Object.assign(channel, {
        id: channel.id,
        ModulesChatsId: getters.ChatModuleInfo.Id,
        rowCreated: channel.rowCreated,
        channelImage: uploadResponse.channelImage ? uploadResponse.channelImage : null
      })
      await api.AppModules.SaveChatChannelInfo(newchannel)
    }
    commit(mutationNames.UPDATE_CHAT_CHANNEL_IMAGE, uploadResponse)
  },
  addNewChatChannel ({ commit }, payload) {
    commit(mutationNames.ADD_CHATCHANNEL, payload)
  },
  async saveChatUser ({state, commit}, payload) {
    let response = await api.AppModules.SaveChatUserInfo(payload)
    return response
  },
  async hideMessage ({state, commit}, payload) {
    let response = await api.AppModules.HideChatMessage(payload)
    return response
  },
  async deleteMessage ({state, commit}, chatMessageId) {
    let response = await api.AppModules.DeleteChatMessage(chatMessageId)
    return response
  },
  async banChatUser ({state, commit}, payload) {
    let response = await api.AppModules.BanChatUser(payload)
    return response
  },
  async blockChatUser ({state, commit}, payload) {
    let response = await api.AppModules.BlockChatUser(payload)
    return response
  },
  async getAppAdminList ({state, commit}, subscriptionID) {
    let response = await api.AppModules.GetAppAdminList(subscriptionID)
    return response
  },
  setpageValue ({ commit }, pageval) {
    commit('setpageValue', pageval)
  },
  settakeValue ({ commit }, takeval) {
    commit('settakeValue', takeval)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/appModules/chat.js